<template>
<div class='nw-phone-container'>
  <div class='nw-phone-wrap'>
    <div class='nw-country' @click="select" :class='{disabled: disabled}'>
      <span>+</span>
      <p>{{country}}</p>
      <i class="iconfont">&#xe604;</i>
    </div>
    <input type="text" :disabled='disabled' v-model="currentValue" :placeholder="placeholder" :maxlength='length' class='nw-input' @input='input' @blur='blur' @focus='focus'>
  </div>
  <span class="nw-error-text" v-show='error' v-html="error"></span>
  <div class='nw-country-dropdown' v-show="!mobile && active">
    <div class='nw-cover' @click="hideModal"></div>
    <ul>
      <li v-for='(item, i) in phonelists' :key='i' @click="pcselect(item.code)">
        <span>{{item.cn}}</span>
        <p><span class='nw-add'>+</span>{{item.code}}</p>
      </li>
    </ul>
  </div>

  <!-- <transition name='nw-picker'> -->
  <div class="nw-picker" v-if="mobile && active" @click.self="hideModal">
    <div class="nw-picker-content">
      <div class="picker-btns">
        <span @click="hideModal">取消</span>
        <span class="nw-active" @click="saveSelect">确认</span>
      </div>
      <smooth-picker :data="phonelistsData" :change="selectChange" ref="smoothPicker"/>
    </div>
  </div>
  <!-- </transition> -->
</div>
</template>

<script>
// import UserService from '../../service/user'
import { mapState } from 'vuex'
import validateMethods from '../../utils/validate'
import cellphone from './cellphone'
import VueBus from '../../utils/bus.js'

export default {
  name: 'phone-filed',
  data () {
    return {
      currentValue: this.value,
      active: false,
      error: '',
      phonelists: [],
      country: this.selectCode || 86,
      mobileSelectCountry: 86, // 移动端选择过程中不能直接修改country，有取消
      phonePass: false
    }
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请输入手机号'
    },
    length: {
      // 限制输入长度
      type: Number,
      default: 11
    },
    getCountry: {
      type: Function,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    selectCode: { // 当禁用表单时，这个地区的值需要传过来
      type: Number,
      default: 86
    }
  },
  computed: {
    ...mapState({
      mobile: 'mobile'
    }),
    phonelistsData () {
      let cn = this.phonelists.map(item => `${item.cn} `)
      let code = this.phonelists.map(item => `+${item.code} `)
      return [
        {
          currentIndex: 0,
          list: cn,
          textAlign: 'right',
          className: 'left-group'
        },
        {
          currentIndex: 0,
          list: code,
          textAlign: 'left',
          className: 'right-group'
        }
      ]
    },
    href () {
      return window.location.href
    }
  },
  created () {
    // 获取电话列表
    if (!this.disabled) {
      // if (window.localStorage) {
      //   if (localStorage.phonelists) {
      //     this.phonelists = JSON.parse(localStorage.phonelists)
      //   } else {
      //     UserService.getCellphoneList().then(res => {
      //       localStorage.phonelists = JSON.stringify(res)
      //       this.phonelists = res
      //     }).catch(err => {
      //       console.log(err)
      //     })
      //   }
      // } else {
      //   UserService.getCellphoneList().then(res => {
      //     this.phonelists = res
      //   }).catch(err => {
      //     console.log(err)
      //   })
      // }
      this.phonelists = cellphone
    }
    // vuebus 错误提示
    VueBus.$on('error', (info) => {
      this.error = info.msg
    })
  },
  watch: {
    active (newVal) {
      if (newVal && this.mobile) {
        document.documentElement.style.height = '100%'
        document.body.style.height = '100%'
        document.body.style.overflow = 'hidden'
      }
      if (!newVal && this.mobile) {
        document.documentElement.removeAttribute('style')
        document.body.removeAttribute('style')
      }
    },
    value (val) {
      this.setCurrentValue(val)
    }
  },
  methods: {
    select () {
      if (this.disabled) {
        return
      }
      this.active = !this.active
    },
    setCurrentValue (value) {
      this.currentValue = value
    },
    hideModal () {
      this.active = false
    },
    input (e) {
      this.$emit('input', e.target.value)
    },
    blur () {
      this.$emit('blur')
      this.$emit('phoneState', false)
      if (!validateMethods.checkEmpty(this.currentValue)) {
        this.error = '请输入手机号'
        return
      }
      if (!validateMethods.checkMobile(this.currentValue, this.country)) {
        this.error = '手机号格式错误'
      }
    },
    focus () {
      this.error = ''
      this.$emit('focus')
    },
    pcselect (country) {
      this.country = country
      this.active = false
      this.$emit('setCountry', this.country)
    },
    saveSelect () {
      this.country = this.mobileSelectCountry
      this.active = false
      this.$emit('setCountry', this.country)
    },
    selectChange (gIndex, iIndex) {
      this.mobileSelectCountry = this.phonelists[iIndex].code
      let setGIndex = gIndex ? 0 : 1
      this.$refs.smoothPicker.setGroupData(setGIndex, Object.assign({}, this.phonelistsData[setGIndex], { currentIndex: iIndex }))
      this.$refs.smoothPicker.setGroupData(gIndex, Object.assign({}, this.phonelistsData[gIndex], { currentIndex: iIndex }))
    },
    // public
    check () {
      if (!validateMethods.checkEmpty(this.currentValue)) {
        this.error = '请输入手机号'
        return false
      }
      if (!validateMethods.checkMobile(this.currentValue, this.country)) {
        this.error = '手机号格式错误'
        return false
      }
      return true
    }
  }
}
</script>

<style lang='scss' scoped>
@import '../../assets/css/common';
// 覆盖smooth-picker
.smooth-picker .smooth-handle-layer .smooth-top{
  border-bottom: 1px solid rgba(200, 199, 204, .5) !important;
}
.smooth-picker .smooth-handle-layer .smooth-bottom{
  border-top: 1px solid rgba(200, 199, 204, .5) !important;
}

.nw-phone-container{
  position: relative;
  // margin-bottom: 12px;
}
.nw-phone-wrap{
  display: flex;
  justify-content: space-between;
}
.nw-country{
  flex-shrink: 0;
  border: 1px solid $border;
  border-right: none;
  border-top-left-radius: $border-radius;
  border-bottom-left-radius: $border-radius;
  height: 38px;
  // margin-bottom: 12px;
  cursor: pointer;
  padding-left: 1.8rem;
  padding-right: 1.8rem;
  position: relative;
  &.disabled {
    cursor: not-allowed;
  }
  p{
    font-size: 14px;
    line-height: 38px;
  }
  span{
    position: absolute;
    left: 1rem;
    font-size: 16px;
    top: 6.4px;
  }
  i{
    position: absolute;
    right: .6rem;
    top: 9px;
    font-size: .8rem;
    color: #000;
    // transform: rotateZ(90deg)
  }
}
.nw-input{
  flex-grow: 1;
  background-color: #ffffff;
  color: $black;
  font-size: 14px;
  height: 38px;
  padding-left: 12px;
  border-radius: 0;
  border-top-right-radius: $border-radius;
  border-bottom-right-radius: $border-radius;
  border: 1px solid $border;
  transition: all 0.3s;
  // margin-bottom: 12px;
  -webkit-appearance: textfield;
  &:disabled{
    cursor: not-allowed;
  }
  &:focus, &:active{
    outline: none;
    box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  }
  &::-webkit-input-placeholder{  /* WebKit, Blink, Edge */
    color: #bbbec4;
    font-size: 12px;
  }
  &:-moz-placeholder{  /* Mozilla Firefox 4 to 18 */
    color: #bbbec4;
    font-size: 12px;
  }
  &::-moz-placeholder{  /* Mozilla Firefox 19+ */
    color: #bbbec4;
    font-size: 12px;
  }
  &:-ms-input-placeholder{ /* Internet Explorer 10-11 */
    color: #bbbec4;
    font-size: 12px;
  }
}
.nw-error-text{
  font-size: 0.875rem;
  color: #D7B375;
  padding-left: 0.5rem;
}
.nw-country-dropdown{
  position: absolute;
  background-color: #fff;
  z-index: 15;
  width: 100%;
  margin-right: 1.5rem;
  top: 45px;
  border-radius: $border-radius;
  font-size: 14px;
  .nw-cover{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: transparent;
    z-index: -1;
  }
  ul{
    max-height: 260px;
    margin-right: 1.5rem;
    border: 1px solid $border;
    overflow-y: auto;
    li{
      cursor: pointer;
      height: 33px;
      line-height: 33px;
      padding: 0 1rem;
      display: flex;
      justify-content: space-between;
      &:hover{
        background-color: #e8e8e8;
      }
      p{
        .nw-add{
          font-size: 1.2rem;
          line-height: 1;
          margin-right: .1rem;
        }
      }
    }
  }
}

.nw-picker{
  position: fixed;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  background-color: rgba(0,0,0,.2);
  z-index: 20;
  .nw-picker-content{
    background-color: $gray-lighter;
    position: absolute;
    bottom: 0;
    width: 100%;
    .picker-btns{
      border-top: 1px solid #c8c7cc;
      display: flex;
      justify-content: space-between;
      span{
        color: $black;
        padding: .5rem;
        cursor: pointer;
        &.nw-active{
          color: $orange;
        }
      }
    }
    .left-group{
      .smooth-item{
        text-align: right;
        padding-right: 1rem;
      }
    }
    .right-group{
      .smooth-item{
        text-align: left;
        padding-left: 1rem;
      }
    }
  }
}
// .nw-picker-enter-active, .nw-picker-leave-active {
//   transition: all .35s;
// }
// .nw-picker-enter, .nw-picker-leave-to {
//   opacity: 0;
//   transform: translate(0px, 100%);
// }
</style>
